import React, { useState } from 'react';
import axios from 'axios';
import { KeyRound } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { useAuth } from '../context/AuthContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const ForcePasswordChange = () => {
  const { user, updateUser, logout } = useAuth();
  const [f, setF] = useState({ current_password: '', new_password: '', confirm: '' });
  const [busy, setBusy] = useState(false);
  if (!user?.must_change_password) return null;

  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    if (f.new_password.length < 8) return toast.error('Use at least 8 characters');
    if (f.new_password !== f.confirm) return toast.error("The new passwords don't match");
    setBusy(true);
    try {
      await axios.post(`${API}/auth/change-password`, { current_password: f.current_password, new_password: f.new_password });
      updateUser({ ...user, must_change_password: false });
      toast.success('Password updated');
    } catch (err) {
      const d = err.response?.data?.detail;
      toast.error(typeof d === 'string' ? d : 'Could not update password');
    }
    setBusy(false);
  };

  return (
    <div className="fixed inset-0 z-[100] bg-black/60 backdrop-blur-sm flex items-center justify-center p-4" data-testid="force-password-change">
      <form onSubmit={submit} className="w-full max-w-md bg-background rounded-2xl p-6 space-y-4 shadow-xl">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-xl bg-primary/10 flex items-center justify-center"><KeyRound className="w-5 h-5 text-primary" /></div>
          <div>
            <h2 className="text-lg font-bold text-foreground">Choose your own password</h2>
            <p className="text-sm text-muted-foreground">You signed in with a temporary password. Pick a new one to continue.</p>
          </div>
        </div>
        <Input type="password" placeholder="Temporary password from your email" value={f.current_password} onChange={set('current_password')} required data-testid="force-pw-current-input" />
        <Input type="password" placeholder="New password (8+ characters)" value={f.new_password} onChange={set('new_password')} required data-testid="force-pw-new-input" />
        <Input type="password" placeholder="Type the new password again" value={f.confirm} onChange={set('confirm')} required data-testid="force-pw-confirm-input" />
        <Button type="submit" className="w-full" disabled={busy} data-testid="force-pw-submit-btn">{busy ? 'Saving...' : 'Save new password'}</Button>
        <div className="flex justify-between text-xs text-muted-foreground">
          <a href="/forgot-password" onClick={() => logout()} className="hover:text-foreground" data-testid="force-pw-forgot-link">Lost the temporary password?</a>
          <button type="button" onClick={() => { logout(); window.location.href = '/login'; }} className="hover:text-foreground" data-testid="force-pw-logout-btn">Log out</button>
        </div>
      </form>
    </div>
  );
};
